export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Military-Grade Encryption',
      description: 'AES-256 encryption protects your data from hackers and surveillance, ensuring complete privacy.',
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our extensive network of high-speed servers across 50+ countries.',
      gradient: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Lightning Fast Speed',
      description: 'Optimized protocols ensure blazing-fast connections without compromising your security.',
      gradient: 'from-cyan-500 to-cyan-600'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or share your private data. Your activity remains completely anonymous.',
      gradient: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Kill Switch Protection',
      description: 'Automatic protection that blocks all internet traffic if your VPN connection drops unexpectedly.',
      gradient: 'from-red-500 to-red-600'
    },
    {
      icon: 'ri-devices-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously with one account. Works on Windows, Mac, iOS, Android, and Linux.',
      gradient: 'from-orange-500 to-orange-600'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-purple-600 font-semibold text-sm uppercase tracking-wide">
            Why Choose AGIT VPN
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Enterprise-Grade Security
            <br />
            for Everyone
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Powerful features designed to protect your online privacy and freedom
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-2xl flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
